import { render, staticRenderFns } from "./ItemUpdate.vue?vue&type=template&id=1126503e&scoped=true&"
import script from "./ItemUpdate.vue?vue&type=script&lang=js&"
export * from "./ItemUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1126503e",
  null
  
)

export default component.exports